import { useState } from "react";
import Dialogo from "./Dialogo";

// «No puedo»: la respuesta a un encargo que no se va a hacer. El motivo es obligatorio porque lo lee
// quien la mando; no hay «Descartar» para las tareas enviadas.
export default function NoPuedoModal({ tarea, onCerrar, onEnviar }) {
  const [motivo, setMotivo] = useState("");
  const [error, setError] = useState("");
  const [enviando, setEnviando] = useState(false);
  const de = tarea.enviada_por?.nombre || "quien te la mandó";

  const enviar = async e => {
    e.preventDefault();
    if (!motivo.trim()) return setError("Cuenta por qué no puedes: quien te la mandó lo va a leer");
    setEnviando(true); setError("");
    try { await onEnviar(motivo.trim()); }
    catch (err) { setError(err?.message || "No se ha podido enviar el motivo"); setEnviando(false); }
  };

  return (
    <Dialogo titulo="No puedo hacer esta tarea" onCerrar={onCerrar} ancho={420}>
      <form className="mt-form" onSubmit={enviar} noValidate>
        <p className="mt-nopuedo-t">{tarea.titulo}</p>
        <p className="mt-sel-nota">{de} verá tu motivo y recibirá un aviso.</p>
        <label className="mt-lb" htmlFor="mt-motivo">Motivo (obligatorio)</label>
        <textarea id="mt-motivo" className="mt-inp" rows={3} maxLength={500} placeholder="Por ejemplo: no me da tiempo esta semana" value={motivo} onChange={e => setMotivo(e.target.value)} />
        {error && <div className="mt-plan-aviso" role="alert"><span>{error}</span></div>}
        <div className="mt-dlg-pie">
          <button type="button" className="mt-b btn" onClick={onCerrar}>Cancelar</button>
          <button type="submit" className="mt-b p btn" disabled={enviando}>Enviar motivo</button>
        </div>
      </form>
    </Dialogo>
  );
}
